(() => {
  const formatDate = (value) => {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  };

  const createCard = (item, options) => {
    if (!item || !item.title || !item.url) return null;

    const card = document.createElement('a');
    card.className = 'home-social-hub__card';
    card.href = item.url;
    card.target = '_blank';
    card.rel = 'noopener noreferrer';

    if (options.showThumbnail && item.thumbnail) {
      const media = document.createElement('div');
      media.className = 'home-social-hub__media';

      const image = document.createElement('img');
      image.src = item.thumbnail;
      image.alt = item.title;
      image.loading = 'lazy';
      image.decoding = 'async';

      media.appendChild(image);
      card.appendChild(media);
    }

    const body = document.createElement('div');
    body.className = 'home-social-hub__body';

    const formattedDate = formatDate(item.published_at);
    if (formattedDate) {
      const date = document.createElement('p');
      date.className = 'home-social-hub__date';
      date.textContent = formattedDate;
      body.appendChild(date);
    }

    const title = document.createElement('h3');
    title.className = 'home-social-hub__title';
    title.textContent = item.title;
    body.appendChild(title);

    if (options.showExcerpt && item.excerpt) {
      const excerpt = document.createElement('p');
      excerpt.className = 'home-social-hub__text';
      excerpt.textContent = item.excerpt;
      body.appendChild(excerpt);
    }

    card.appendChild(body);
    return card;
  };

  const loadFeed = async (section) => {
    const feedUrl = section.dataset.feedUrl;
    if (!feedUrl || section.dataset.loaded === 'true') return;

    const list = section.querySelector('[data-note-list]');
    if (!list) return;

    try {
      const response = await fetch(feedUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'omit',
      });

      if (!response.ok) return;

      const payload = await response.json();
      if (!Array.isArray(payload) || payload.length === 0) return;

      const count = Number(section.dataset.count || 3);
      const showExcerpt = section.dataset.showExcerpt === 'true';
      const showThumbnail = section.dataset.showThumbnail === 'true';

      const fragment = document.createDocumentFragment();
      payload.slice(0, count).forEach((item) => {
        const card = createCard(item, { showExcerpt, showThumbnail });
        if (card) fragment.appendChild(card);
      });

      if (!fragment.childNodes.length) return;

      list.innerHTML = '';
      list.appendChild(fragment);
      section.dataset.loaded = 'true';
    } catch (_error) {
      // Keep the manual fallback silently.
    }
  };

  const init = () => {
    document.querySelectorAll('[data-note-feed]').forEach((section) => {
      loadFeed(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector('[data-note-feed]') || event.target?.matches?.('[data-note-feed]')) {
      init();
    }
  });
})();
